export const ReportSurface = Object.freeze({
  CLASSIC: 'classic',
  CONVERSATIONAL: 'conversational',
});

export default function buildReportEventProps({ reportSlug, surface, ...extra } = {}) {
  return {
    reportSlug: reportSlug || null,
    surface: surface || ReportSurface.CLASSIC,
    ...extra,
  };
}
